/**
 * Where a pick came from, as a chip.
 *
 * The distinction the chip carries is the whole point of the citation work: a
 * `manual` basis resolved against the compiled rulebook and one that did not
 * are different claims, and only the first is evidence.
 */

import type { BasisResolution } from "./types";
import { Tip } from "./Tip";

const FACE: Record<string, { word: string; chip: string }> = {
  "ladder": { word: "Movement ladder", chip: "Ladder" },
  "manual": { word: "Manual rule", chip: "Manual" },
  "manual-verified": { word: "Manual rule", chip: "Manual" },
  "manual-unverified": { word: "Unverified claim", chip: "Unverified" },
  "creative": { word: "Off-documentation", chip: "Off-manual" },
};

export function BasisChip({ basis }: { basis: BasisResolution }) {
  const face = FACE[basis.kind] || FACE["manual-unverified"];
  return (
    <Tip
      sub={basis.note || undefined}
      text={`${face.word} — ${basis.cited || basis.raw || "none stated"}`}
    >
      <span className={`pr-basis pr-basis-${basis.kind}`}>{face.chip}</span>
    </Tip>
  );
}
